import { useState, useRef } from "react";
import classNames from "classnames";

import useIntersectionObserver from "hooks/@common/useIntersectionObserver";

import styles from "./ImageRenderer.module.scss";

//* 이미지가 없을 때는 배경색이 채워진 빈공간 상태임
//* webp 이미지와 fallback 이미지 확장자를 지원함

const ImageRenderer = ({ width = "100%", height = "100%", alt = "", className = "", webp = "", src, ...props }) => {
  const imgRef = useRef();
  const [isLoaded, setIsLoaded] = useState(false);
  const entry = useIntersectionObserver(imgRef, { freezeOnceVisible: true });

  return (
    <div className={classNames(styles.container, className)} ref={imgRef} style={{ width: width, height: height }}>
      {!!entry?.isIntersecting && (
        <picture
          onLoad={() => {
            setTimeout(() => {
              setIsLoaded(true);
            }, 100);
          }}
          data-isloaded={isLoaded}
        >
          <source srcSet={webp} type="image/webp" />
          <img alt={alt} src={src} {...props} draggable="false" />
        </picture>
      )}
    </div>
  );
};

export default ImageRenderer;
